import {
  REQUEST_PREOPEN_MANAGER_REJECTED_CLAIMS,
  SET_PREOPEN_MANAGER_REJECTED_CLAIMS,
} from 'containers/PreOpenManagerRejectedClaims/constants';

export const requestRejectedClaims = (
  status: string,
  page: number,
  pageSize: number,
) => ({
  type: REQUEST_PREOPEN_MANAGER_REJECTED_CLAIMS,
  status,
  page,
  pageSize,
});

export const setRejectedClaims = (response: any) => ({
  type: SET_PREOPEN_MANAGER_REJECTED_CLAIMS,
  response,
});
